<div class="row">
  <div class="col-md-12">
    <fui-heading [text]="'com.showcases' | translate" [level]="5"></fui-heading>
    {{ "com.showcases_account_desc" | translate }}
    <br />
    <br />
    <myp-inline-loader [loading]="loading" height="100px" spinnerName="loadingShowcases"></myp-inline-loader>
    @for (showcase of showcases; track showcase) {
      <div class="m-t-30">
        <div class="d-flex m-b-10 justify-content-between">
          <span class="t-20 bold d-block">{{ showcase.description || "No description entered..." }}</span>
          <fa-icon icon="ellipsis-h" class="circle-icon-btn" (click)="showcaseOptions(showcase)"></fa-icon>
        </div>
        @if (communityService.displayAudioWaveforms) {
          <myp-waveform-comments [showComments]="false" #waveformComments [isPostAttachment]="true" [file]="showcase"></myp-waveform-comments>
        }
        @if (!communityService.displayAudioWaveforms) {
          <div class="post-audio-play" [class.pulse-blue]="communityService.playingAudioFile && communityService.playingAudioFile.id == showcase.id" (click)="playAudio(showcase, $event)">
            @if (!workspaceService.uploadingFilesSessionMap[showcase.id] || workspaceService.uploadingFilesSessionMap[showcase.id].progress == 100) {
              <fa-icon [icon]="communityService.playingAudioFile && communityService.playingAudioFile.id == showcase.id ? 'stop-circle' : 'play-circle'" class="t-40"></fa-icon>
            }
            @if (workspaceService.uploadingFilesSessionMap[showcase.id] && workspaceService.uploadingFilesSessionMap[showcase.id].progress != 100) {
              <round-progress
                [current]="workspaceService.uploadingFilesSessionMap[showcase.id].progress"
                max="100"
                [color]="'#45ccce'"
                [background]="'#eaeaea'"
                [radius]="30"
                [stroke]="5"
                [semicircle]="false"
                [rounded]="true"
                [clockwise]="true"
                [responsive]="false"
                [duration]="250"
                [animation]="'easeInOutQuart'"
                [animationDelay]="0"
              ></round-progress>
            }
            <div class="d-flex m-l-10 align-items-center">
              <div>
                <span class="t-20 bold d-block">{{ showcase.filename }}</span>
                <span class="text-muted t-16">{{ showcase.filesize | bytesToSize }}</span>
              </div>
            </div>
          </div>
        }
        <div class="d-flex flex-wrap align-items-center position-relative m-t-5">
          <span class="t-12 text-muted">{{ "com.skills_word" | translate }}:</span>
          @if (!showcase.skills || !showcase.skills.length) {
            <span class="t-12 text-muted m-l-5">{{ "com.showcase_no_skills" | translate }}</span>
          }
          @for (channel of showcase.skills; track channel) {
            <span class="showcase-selected-skill">
              {{ "com.skills." + channel.string_id | translate }}
              <fa-icon icon="times-circle" class="m-l-5" (click)="removeSkill(channel, showcase)"></fa-icon>
            </span>
          }
          @if (!showcase.skills || showcase.skills.length < 3) {
            <span class="add-channel-button">
              @if (showcase.loadingSkills) {
                <fa-icon icon="spinner" class="t-14 pointer m-l-10" [animation]="'spin'"></fa-icon>
              }
              @if (!showcase.loadingSkills) {
                <fa-icon icon="plus-circle" class="c-green t-14 pointer m-l-10" (click)="showcase.shouldShowChannelSelector = !showcase.shouldShowChannelSelector"></fa-icon>
              }
            </span>
          }
          @if (showcase.shouldShowChannelSelector) {
            <div class="channel-selector">
              <div class="overflow-auto h-100">
                @for (skill of communityService.availableSkills; track skill) {
                  <div class="bold pointer t-14 p-1" (click)="addSkill(skill, showcase)">
                    <fa-icon icon="plus-circle" class="c-green"></fa-icon>
                    {{ "com.skills." + skill.string_id | translate }}
                  </div>
                }
              </div>
            </div>
          }
        </div>
      </div>
    }

    <Br />
    <a class="small-btn" (click)="addShowcase()">{{ "com.add_showcase" | translate }}</a>
  </div>
</div>
